import CryptoJS from "crypto-js";

export const decryptData = (encryptedData: any, iv: string) => {
  const secret ="aSFGBTYP&&&&WQE123OHNDJHT";

  // replicate Node.js SHA256 buffer
  const hash = CryptoJS.SHA256(secret);
  const key = CryptoJS.enc.Hex.parse(hash.toString(CryptoJS.enc.Hex));

  const decrypted = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Hex.parse(encryptedData.data),
    } as any,
    key,
    {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);


  if (!decryptedText) {
    throw new Error("Decryption failed");
  }

  return JSON.parse(decryptedText);
};

export const encryptPassword = (password: string) => {
  const secretKey ="aSFGBTYP&&&&WQE123OHNDJHT" // must match backend
  return CryptoJS.AES.encrypt(password, secretKey).toString();
}